import React from 'react';
import { motion } from 'framer-motion';

interface PageTransitionProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Page transition component that provides smooth animations
 * Uses Framer Motion for consistent, performant animations
 */
const PageTransition: React.FC<PageTransitionProps> = ({ children, className = '' }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ 
        duration: 0.3, 
        ease: 'easeInOut',
        type: 'tween'
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
